import React from 'react';
import TermsPage from '../termsPage/TermsPage';

export default function B2BTermsPage() {
  return <TermsPage defaultSection="stationOwner" />;
}
